import React from "react";
import { Sparkles, Mail, Phone, ArrowRight } from "lucide-react";
import { Reveal, Section, Container, EyebrowLarge } from "./Shared";

export default function ConnectWithUs() {
    return (
        <>
            <Section id="contact" className="relative font-body py-24 md:py-32">
                {/* Background Ambience */}
                <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px] rounded-full blur-[120px] pointer-events-none opacity-[0.1]" style={{ background: 'var(--ivani-color)' }} />

                <Container>
                    <div className="text-center mb-16">
                        <EyebrowLarge>CONNECT WITH US</EyebrowLarge>
                    </div>

                    <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 max-w-6xl mx-auto">
                        <Reveal className="h-full">
                            <div className="h-full glass-card sm:p-8 py-6 px-3 md:p-12 rounded-[40px] border border-white/10 flex flex-col justify-between">
                                <div>
                                    <div className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/10 px-4 py-1.5 text-sm text-white mb-8 backdrop-blur-md">
                                        <Sparkles className="h-3.5 w-3.5" />
                                        <span>New project?</span>
                                    </div>

                                    <h4 className="font-heading text-3xl md:text-5xl font-bold text-white mb-6 leading-tight">
                                        Let’s make the <br />
                                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-zinc-500">right connection.</span>
                                    </h4>

                                    <p className="text-zinc-400 text-lg leading-relaxed max-w-md">
                                        Send a short brief — we’ll reply with a plan, timeline, and quote within 24 hours.
                                    </p>
                                </div>

                                <div className="mt-12 space-y-6">
                                    <div className="flex items-center gap-4 group">
                                        <div className="w-12 h-12 rounded-full bg-white/5 border border-white/10 flex items-center justify-center group-hover:bg-white group-hover:text-black transition-all duration-300 text-white">
                                            <Mail className="h-5 w-5" />
                                        </div>
                                        <a href="mailto:smita@ivaniconsultancy.com" className="text-md sm:text-lg text-white hover:text-zinc-300 transition-colors">
                                            smita@ivaniconsultancy.com
                                        </a>
                                    </div>

                                    <div className="flex items-center gap-4 group">
                                        <div className="w-12 h-12 rounded-full bg-white/5 border border-white/10 flex items-center justify-center group-hover:bg-white group-hover:text-black transition-all duration-300 text-white">
                                            <Phone className="h-5 w-5" />
                                        </div>
                                        <a href="tel:+918618509238" className="text-md sm:text-lg text-white hover:text-zinc-300 transition-colors">
                                            +91 8618509238
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </Reveal>

                        <Reveal className="h-full">
                            <form className="h-full glass-card p-8 md:p-12 rounded-[40px] border border-white/10 bg-zinc-900/50 backdrop-blur-xl">
                                <div className="space-y-6">
                                    <div>
                                        <label className="block text-sm font-medium text-zinc-400 mb-2 ml-1">Your name</label>
                                        <input
                                            className="w-full rounded-2xl border border-white/10 bg-white/5 px-6 py-4 text-white placeholder:text-zinc-600 focus:outline-none focus:border-white/30 focus:bg-white/10 transition-all"
                                            placeholder="Jane Doe"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-zinc-400 mb-2 ml-1">Email</label>
                                        <input
                                            className="w-full rounded-2xl border border-white/10 bg-white/5 px-6 py-4 text-white placeholder:text-zinc-600 focus:outline-none focus:border-white/30 focus:bg-white/10 transition-all"
                                            placeholder="you@company.com"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-zinc-400 mb-2 ml-1">Brief</label>
                                        <textarea
                                            className="w-full h-32 rounded-2xl border border-white/10 bg-white/5 px-6 py-4 text-white placeholder:text-zinc-600 focus:outline-none focus:border-white/30 focus:bg-white/10 transition-all resize-none"
                                            placeholder="What are you trying to connect?"
                                        />
                                    </div>

                                    <button
                                        type="submit"
                                        className="w-full mt-4 flex items-center justify-center gap-2 rounded-full bg-white text-black px-8 py-4 font-bold text-lg hover:bg-zinc-200 hover:-translate-y-1 transition-all duration-300"
                                    >
                                        Send request <ArrowRight className="h-5 w-5" />
                                    </button>
                                </div>
                            </form>
                        </Reveal>
                    </div>
                </Container>
            </Section>

            {/* Footer */}
            <div className="py-12 border-t border-white/5 text-center">
                <p className="text-zinc-600 text-sm font-light">
                    © {new Date().getFullYear()} IVANI Consulting. All rights reserved.
                </p>
            </div>
        </>
    );
}
